// Plan prices on bonusly.com/pricing. USD display is locale-agnostic; update
// here when catalog pricing changes.
export const TEAM_PLUS_BIZY_AI_MONTHLY_PRICE_DISPLAY = '$5';
export const FREE_PLAN_PRICE_DISPLAY = '$0';
